function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoundcloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2375 1113",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M489.214,106.894C482.808,106.894 476.493,107.651 470.335,109.151C466.861,81.145 454.055,55.283 433.596,35.372C410.262,12.663 379.471,0.156 346.903,0.156L346.843,0.156C326.917,0.156 307.056,5.041 289.405,14.282C286.472,15.817 284.634,18.853 284.634,22.162L284.634,258.107C284.634,263.019 288.617,267 293.53,267L489.214,267C533.356,267 569.268,231.089 569.268,186.947C569.268,142.805 533.356,106.894 489.214,106.894Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.054,124.684C75.141,124.684 71.159,128.666 71.159,133.578L71.159,258.107C71.159,263.019 75.141,267 80.054,267C84.966,267 88.948,263.019 88.948,258.107L88.948,133.578C88.948,128.666 84.966,124.684 80.054,124.684Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.474,124.684C39.562,124.684 35.58,128.666 35.58,133.578L35.58,249.21C35.58,254.123 39.562,258.107 44.474,258.107C49.387,258.107 53.369,254.123 53.369,249.21L53.369,133.578C53.369,128.666 49.387,124.684 44.474,124.684Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.894,151.366C3.982,151.366 0,155.35 0,160.262L0,231.422C0,236.335 3.982,240.317 8.894,240.317C13.807,240.317 17.789,236.335 17.789,231.422L17.789,160.262C17.789,155.35 13.807,151.366 8.894,151.366Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.633,89.105C110.721,89.105 106.738,93.087 106.738,98L106.738,258.107C106.738,263.019 110.721,267 115.633,267C120.545,267 124.527,263.019 124.527,258.107L124.527,98C124.527,93.087 120.545,89.105 115.633,89.105Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.212,62.42C146.3,62.42 142.317,66.403 142.317,71.315L142.317,258.107C142.317,263.019 146.3,267 151.212,267C156.124,267 160.107,263.019 160.107,258.107L160.107,71.315C160.107,66.403 156.124,62.42 151.212,62.42Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.95,26.841C253.037,26.841 249.055,30.823 249.055,35.736L249.055,258.107C249.055,263.019 253.037,267 257.95,267C262.862,267 266.845,263.019 266.845,258.107L266.845,35.736C266.845,30.823 262.862,26.841 257.95,26.841Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.791,53.525C181.879,53.525 177.896,57.508 177.896,62.42L177.896,258.107C177.896,263.019 181.879,267 186.791,267C191.704,267 195.686,263.019 195.686,258.107L195.686,62.42C195.686,57.508 191.704,53.525 186.791,53.525Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.37,62.42C217.458,62.42 213.475,66.403 213.475,71.315L213.475,258.107C213.475,263.019 217.458,267 222.37,267C227.283,267 231.265,263.019 231.265,258.107L231.265,71.315C231.265,66.403 227.283,62.42 222.37,62.42Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundcloud);
export default __webpack_public_path__ + "static/media/Soundcloud.9382f095.svg";
export { ForwardRef as ReactComponent };